import React from 'react';
import styled from 'styled-components';
import { colors } from '../../styles/variables';

const InstructorsSection = styled.section`
  padding: 80px 24px;
  background-color: ${colors.lightGray};
`;

const SectionContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 16px;
`;

const SectionSubtitle = styled.p`
  font-size: 18px;
  color: ${colors.textGray};
  margin-bottom: 16px;
`;

const AvatarNote = styled.p`
  font-size: 13px;
  color: ${colors.tertiary};
  margin: 0 0 32px;
  opacity: 0.85;
`;

const InstructorsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
`;

const InstructorCard = styled.div`
  background-color: ${colors.white};
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

const InstructorImage = styled.div`
  height: 200px;
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const AvatarBadge = styled.span`
  position: absolute;
  left: 8px;
  bottom: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 999px;
  letter-spacing: 0.2px;
`;

const InstructorContent = styled.div`
  padding: 24px;
`;

const InstructorName = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 8px;
`;

const InstructorTitle = styled.p`
  font-size: 16px;
  color: ${colors.secondary};
  margin-bottom: 16px;
`;

const InstructorBio = styled.p`
  font-size: 16px;
  color: ${colors.textGray};
`;

const CourseInstructors = ({ subtitle, instructors }) => {
  return (
    <InstructorsSection>
      <SectionContainer>
        <SectionTitle>강사진 소개</SectionTitle>
        <SectionSubtitle>{subtitle}</SectionSubtitle>
        <AvatarNote>
          * Zoom 미팅은 얼굴 노출이 기본이 아니며, 강사진 사진도 AI 생성 아바타로 표시됩니다.
        </AvatarNote>

        <InstructorsGrid>
          {instructors.map((instructor, index) => (
            <InstructorCard key={index}>
              <InstructorImage>
                <img src={instructor.image} alt={`${instructor.name} (Zoom용 AI 생성 아바타)`} />
                <AvatarBadge>Zoom AI 아바타</AvatarBadge>
              </InstructorImage>
              <InstructorContent>
                <InstructorName>{instructor.name}</InstructorName>
                <InstructorTitle>{instructor.title}</InstructorTitle>
                <InstructorBio>{instructor.bio}</InstructorBio>
              </InstructorContent>
            </InstructorCard>
          ))}
        </InstructorsGrid>
      </SectionContainer>
    </InstructorsSection>
  );
};

export default CourseInstructors;